// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__Kx5pU","submit":"LoginForm_submit__HE7CG","selector":"LoginForm_selector__bBAfX","preloader":"LoginForm_preloader__nrNtq"};